import commonPt from './pt/common.json';
import commonEn from './en/common.json';
import commonEs from './es/common.json';
import orderStatusPt from './pt/orderStatus.json';
import orderStatusEn from './en/orderStatus.json';
import orderStatusEs from './es/orderStatus.json';
import modalTalkToProducerPt from './pt/modalTalkToProducer.json';
import modalTalkToProducerEn from './en/modalTalkToProducer.json';
import modalTalkToProducerEs from './es/modalTalkToProducer.json';

export const common = {
  pt: commonPt,
  en: commonEn,
  es: commonEs
};

export const orderStatus = {
  pt: orderStatusPt,
  en: orderStatusEn,
  es: orderStatusEs
};

export const modalTalkToProducer = {
  pt: modalTalkToProducerPt,
  en: modalTalkToProducerEn,
  es: modalTalkToProducerEs
};